var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "l-calendar-grid c-calendar__card-group" },
    [
      _c("div", { staticClass: "c-calendar__kolonne" }, [
        _c("span", { staticClass: "c-calendar__kolonne-number" }, [
          _vm._v(_vm._s(_vm.kolonne_number)),
        ]),
      ]),
      _vm._v(" "),
      _vm._l(this.days_of_week, function (date, i) {
        return _c(
          "div",
          { key: i, staticClass: "l-calendar-grid__cell" },
          [
            _c("v-week-day", {
              attrs: {
                row_id: _vm.id,
                id: i,
                index: _vm.index,
                kolonne_number: _vm.kolonne_number,
                date: date,
                weekday_objects: _vm.weekday_objects,
                week_results: _vm.week_results,
                holidays: _vm.holidays,
              },
            }),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }